import { cashBackQuantities } from "../../assets/helpers/options";

export const fleetLocationTableheader = [
  { name: "Unidad", value: "name", sortable: false },
  { name: "Estatus de Unidad", value: "contact", sortable: false },
  {
    name: "Fecha de la ultima actualización",
    value: "contact",
    sortable: false,
  },
  { name: "Ubicación", value: "contact", sortable: false },
];

export const driversLocationTableheader = [
  { name: "Tipo de Chofer", value: "name", sortable: false },
  { name: "Chofer", value: "contact", sortable: false },
  {
    name: "Status",
    value: "contact",
    sortable: false,
  },
  { name: "Unidad Asignada", value: "contact", sortable: false },
  { name: "Ubicación", value: "contact", sortable: false },
];

export const casesTrackingTableHeader = [
  { name: "Código de Servicio", value: "name" },
  { name: "Placa", value: "name", sortable: false },
  { name: "Link de Seguimiento", value: "contact" },
  { name: "Ultima Actualizacion", value: "contact" },
  { name: "Estatus del caso", value: "contact" },
  {
    name: "Moto asignada",
    value: "",
  },
  { name: "Grúa asignada", value: "contact" },
  { name: "Chofer", value: "contact", sortable: false },
  { name: "Fecha de Servicio", value: "contact" },
  // { name: 'Editar', value: 'contact' },
];

export const allianceTableheader = [
  { name: "Empresa", sortable: false },
  { name: "Nombre de beneficiario", sortable: false },
  {
    name: "Cédula",
    sortable: false,
  },
  { name: "Status", sortable: false },
  { name: "Acciones", sortable: false },
];

export const craneTableheader = [
  { name: "Empresa", value: "name", sortable: false },
  { name: "Nombre de contacto", value: "contact", sortable: false },
  { name: "Teléfono", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Identificación", value: "identification", sortable: false },
  { name: "Estado", value: "state", sortable: false },
  { name: "Ciudad", value: "city", sortable: false },
  { name: "Estatus", value: "status", sortable: false },
  { name: "Acción", value: "table-action", sortable: false },
];

export const GarageTableHeader = [
  { name: "Grupo de Facturación", value: "name", sortable: false },
  { name: "Num.Factura", value: "contact", sortable: false },
  { name: "Número Cliente", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Nombre Cliente", value: "identification", sortable: false },
  { name: "Fecha Factura", value: "state", sortable: false },
  { name: "Fecha Cobro", value: "status", sortable: false },
  { name: "Forma Pago", value: "table-action", sortable: false },
  { name: "Condiciones de Pago", value: "table-action", sortable: false },
  { name: "Importe Cobrado", value: "table-action", sortable: false },
  { name: "Total Factura", value: "table-action", sortable: false },
  { name: "Base Imponible", value: "table-action", sortable: false },
  { name: "IVA", value: "table-action", sortable: false },
  { name: "CXC Clientes", value: "table-action", sortable: false },
];

export const usersTableheader = [
  { name: "Nombres", value: "name", sortable: false },
  { name: "Email", value: "contact", sortable: false },
  { name: "Perfil", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Status", value: "state", sortable: false },
  { name: "Creado", value: "status", sortable: false },
  { name: "Modificado", value: "", sortable: false },
  { name: "Acción", value: "", sortable: false },
];

export const selectServiceHeader = [
  { name: "Servicio", value: "name", sortable: false },
  { name: "Status de pago", value: "contact", sortable: false },
  { name: "Proveedor", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Codigo", value: "state", sortable: false },
  { name: "Precio", value: "status", sortable: false },
  { name: "PVP", value: "", sortable: false },
  { name: "", value: "", sortable: false },
];

export const selectCashbackHeader = [
  { name: "Pagado", value: "name", sortable: false },
  { name: "Metodo", value: "name", sortable: false },
  { name: "Monto USD", value: "name", sortable: false },
  { name: "Monto Bs", value: "name", sortable: false },
  { name: "Fecha", value: "name", sortable: false },
  { name: "Referencia", value: "name", sortable: false },
  { name: "Comprobante", value: "name", sortable: false },
  { name: "", value: "name", sortable: false },
];

export const searchInternalProviderTableHeader = [
  { name: "", value: "plus", sortable: false },
  { name: "Nombre", value: "name", sortable: false },
  { name: "Teléfono", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Identificación", value: "contact", sortable: false },
  { name: "Estado", value: "state", sortable: false },
  { name: "Estatus", value: "status", sortable: false },
  { name: "Acción", value: "", sortable: false },
];
export const saleUsersTableheader = [
  { name: "Nombres", value: "name", sortable: false },
  { name: "Email", value: "contact", sortable: false },
  { name: "Perfil", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Turno", value: "", sortable: false },
  { name: "Proveedor", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Status", value: "state", sortable: false },
  { name: "Creado", value: "status", sortable: false },
  { name: "Modificado", value: "", sortable: false },
  { name: "Acción", value: "", sortable: false },
];

export const internalProviderTableHeader = [
  { name: "Nombre", value: "name", sortable: false },
  { name: "Tipo", value: "type", sortable: false },
  { name: "Teléfono", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Identificación", value: "contact", sortable: false },
  { name: "Estado", value: "state", sortable: false },
  { name: "Estatus", value: "status", sortable: false },
  { name: "Acción", value: "", sortable: false },
];

export const scheduledServiceTableHeader = [
  { name: "Operador del caso", value: "name", sortable: false },
  { name: "Fecha de creación", value: "type", sortable: false },
  { name: "Fecha y hora del servicio", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Codigo de servicio", value: "contact", sortable: false },
  { name: "Servicio solicitado", value: "state", sortable: false },
  { name: "Chofer asignado", value: "status", sortable: false },
  { name: "Estatus", value: "", sortable: false },
];

export const vehicularAssetsTableHeader = [
  { name: "Transporte", value: "name", sortable: false },
  { name: "Marca", value: "contact", sortable: false },
  { name: "Modelo", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Color", value: "color", sortable: false },
  { name: "Tipo de Grúa", value: "type", sortable: false },
  { name: "Alias", value: "alias", sortable: false },
  { name: "Placa", value: "state", sortable: false },
  { name: "Año", value: "status", sortable: false },
  { name: "Fecha de Compra", value: "status", sortable: false },
  { name: "Descripción", value: "", sortable: false },
  { name: "Acción", value: "", sortable: false },
];

export const internalProvidersScheduledTableheader = [
  { name: "", value: "plus", sortable: false },
  { name: "Nombre", value: "name", sortable: false },
  { name: "Duracion (min)", value: "time", sortable: false },
  { name: "Teléfono", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Identificación", value: "contact", sortable: false },
  { name: "Estado", value: "state", sortable: false },
  { name: "Estatus", value: "status", sortable: false },
];

export const internalProvidersTableheader = [
  { name: "", value: "", sortable: false },
  { name: "Nombre de contacto", value: "contact", sortable: false },
  { name: "Duracion (min)", value: "phone", sortable: false },
  { name: "Servicio Agendado", value: "region", sortable: false },
  { name: "Teléfono", value: "phone", sortable: false },
  { name: "Identificación", value: "identification", sortable: false },
  { name: "Estado", value: "region", sortable: false },
  { name: "Estatus", value: "status", sortable: false },
];

export const providersTableheader = [
  { name: "", value: "", sortable: false },
  { name: "Empresa", value: "name", sortable: false },
  { name: "Nombre de contacto", value: "contact", sortable: false },
  { name: "Teléfono", value: "phone", sortable: false },
  { name: "Identificación", value: "identification", sortable: false },
  { name: "Estado", value: "region", sortable: false },
  { name: "Estatus", value: "status", sortable: false },
];

export const serviceHistoryTableheader = [
  { name: "Fecha", value: "date", sortable: false },
  { name: "Averia", value: "fault", sortable: false },
  { name: "Servicio", value: "", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Comentario", value: "KMEfectivo", sortable: false },
  { name: "Excepción", value: "", sortable: false },
  { name: "Km", value: "KMEfectivo", sortable: false },
];

export const exportanblesTableheader = [
  { name: "Operador Inicial", value: "name", sortable: false },
  { name: "Operador Final", value: "name", sortable: false },
  { name: "Nro. de caso", value: "contact", sortable: false },
  { name: "Fecha de creación", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Hora de creación", value: "status", sortable: false },
  { name: "Estatus", value: "state", sortable: false },
  { name: "Nombre", value: "", sortable: false },
  { name: "Apellido", value: "", sortable: false },
  { name: "Número", value: "", sortable: true },
  { name: "Placa", value: "", sortable: false },
  { name: "Marca", value: "", sortable: false },
  { name: "Modelo", value: "", sortable: false },
  { name: "Año", value: "", sortable: false },
  { name: "Plan", value: "", sortable: false },
  { name: "Estatus de Afiliación", value: "", sortable: false },
  { name: "Tipo de gestión", value: "", sortable: false },
  { name: "Cliente Afiliado", value: "", sortable: false },
  { name: "Avería", value: "", sortable: false },
  { name: "Alianza", value: "", sortable: false },
  { name: "Avería Real", value: "", sortable: false },
  { name: "Excepción", value: "", sortable: false },
  { name: "KM", value: "", sortable: false },
  { name: "Tipo de dirección origen", value: "", sortable: false },
  { name: "Sótano", value: "", sortable: false },
  { name: "Zona de Origen", value: "", sortable: false },
  // { name: "Estado origen", value: "", sortable: false },
  { name: "Ciudad origen", value: "", sortable: false },
  { name: "Tipo de dirección destino", value: "", sortable: false },
  // { name: "Estado destino", value: "", sortable: false },
  { name: "Ciudad destino", value: "", sortable: false },
  { name: "AV extendido", value: "", sortable: false },
  { name: "Acompañante", value: "", sortable: false },
  { name: "Teléfono del Acompañante", value: "", sortable: false },
  { name: "Placa del Acompañante", value: "", sortable: false },
  { name: "Marca del Acompañante", value: "", sortable: false },
  { name: "Modelo del Acompañante", value: "", sortable: false },
  { name: "Diferencia Aprobada por", value: "", sortable: false },
  { name: "Diferencia Aprobada", value: "", sortable: false },
  { name: "Servicio de taxi", value: "", sortable: false },
  { name: "Código enviado", value: "", sortable: false },
];

export const imageHeader = [
  {
    name: `Imagen AV`,
    value: "",
    sortable: false,
    hidePrint: true,
  },
  {
    name: `Imagen grúa 1`,
    value: "",
    sortable: false,
    hidePrint: true,
  },
  {
    name: `Imagen grúa 2`,
    value: "",
    sortable: false,
    hidePrint: true,
  },
  {
    name: `Imagen grúa 3`,
    value: "",
    sortable: false,
    hidePrint: true,
  },
];

export const stageTimeHeader = [
  {
    name: `Tiempo AV Asignado`,
    value: "",
    sortable: false,
  },
  {
    name: `Tiempo AV en vía`,
    value: "",
    sortable: false,
  },
  {
    name: `Tiempo AV en origen`,
    value: "",
    sortable: false,
  },
  {
    name: `Tiempo en búsqueda grúa`,
    value: "",
    sortable: false,
  },
  {
    name: `Tiempo grúa asginada`,
    value: "",
    sortable: false,
  },
  {
    name: `Tiempo grúa en vía`,
    value: "",
    sortable: false,
  },
  {
    name: `Tiempo en grúa en origen`,
    value: "",
    sortable: false,
  },
  {
    name: `Tiempo cliente vía destino`,
    value: "",
    sortable: false,
  },
  {
    name: `Tiempo total gestión`,
    value: "",
    sortable: false,
  },
  {
    name: `Tiempo carga pendiente`,
    value: "",
    sortable: false,
  },
  {
    name: `Tiempo total ticket`,
    value: "",
    sortable: false,
  },
];

const header = () => {
  let header = [];

  for (let i = 0; i < cashBackQuantities; i++) {
    header.push(
      { name: `Vuelto Venta ${i + 1} USD` },
      { name: `Vuelto Venta ${i + 1} Bs` },
      { name: `Metodo Vuelto Venta ${i + 1}` },
      { name: `Referencia Vuelto Venta ${i + 1}` }
    );
  }
  return header;
};

export const AdminExportableHeader = [
  { name: "Fecha de pago", value: "name", sortable: false },
  { name: "Tipo de gestión", value: "name", sortable: false },
  { name: "Avería", value: "name", sortable: false },
  { name: "Avería real", value: "name", sortable: false },
  { name: "Servicio prestado", value: "name", sortable: false },
  { name: "Código de servicio", value: "name", sortable: false },
  { name: "Fecha de servicio", value: "name", sortable: false },
  { name: "Tipo de ingreso", value: "name", sortable: false },
  { name: "Estatus de Pago", value: "name", sortable: false },
  { name: "Estatus cuenta por cobrar", value: "name", sortable: false },
  { name: "Monto total $", value: "name", sortable: false },
  { name: "Monto total Bs", value: "name", sortable: false },
  { name: "Monto Servicio $", value: "name", sortable: false },
  { name: "Monto Servicio Bs", value: "name", sortable: false },
  { name: "IVA", value: "name", sortable: false },
  { name: "Monto ingresado $", value: "name", sortable: false },
  { name: "Monto ingresado BsS", value: "name", sortable: false },
  { name: "Método de pago", value: "name", sortable: false },
  { name: "Referencia de pago", value: "name", sortable: false },
  { name: "Caja de venta", value: "name", sortable: false },
  { name: "Cuenta por cobrar $", value: "name", sortable: false },
  { name: "Vuelto Total Venta", value: "name", sortable: false },
  ...header(),
  { name: "Validado", value: "name", sortable: false },
];

export const paymentsValidationHeader = [
  { name: "Código de servicio", value: "serviceCode", sortable: false },
  { name: "Fecha de pago", value: "paymentDate", sortable: false },
  { name: "Operador responsable", value: "operator", sortable: false },
  { name: "PVP", value: "pvp", sortable: false },
  { name: "Monto ingresado USD", value: "amountUsd", sortable: false },
  { name: "Monto ingresado Bs", value: "amountBs", sortable: false },
  { name: "Método de pago", value: "paymentMethod", sortable: false },
  { name: "Referencia", value: "reference", sortable: false },
  { name: "Titular", value: "holder", sortable: false },
  { name: "Comprobante", value: "voucher", sortable: false },
  { name: "Tipo de servicio", value: "serviceType", sortable: false },
  { name: "Acción", value: "action", sortable: false },
];

export const locksmithHeader = [
  { name: "Operador", value: "operador", sortable: false },
  { name: "Fecha de creación", value: "fechaCreacion", sortable: false },
  { name: "Código de servicio", value: "codigoServicio", sortable: false },
  { name: "Estatus", value: "estatus", sortable: false },
  { name: "Cliente", value: "cliente", sortable: false },
  { name: "Placa", value: "placa", sortable: false },
  { name: "Ciudad origen", value: "ciudadOrigen", sortable: false },
  { name: "Proveedor recomendado", value: "proveedorRecomendado", sortable: false },
  { name: "Costo del servicio USD", value: "costoServicio", sortable: false },
  { name: "Factura", value: "factura", sortable: false },
  { name: "Reembolso", value: "reembolso", sortable: false },
  { name: "Referencia del reembolso", value: "referenciaReembolso", sortable: false },
  { name: "Comprobante del reembolso", value: "comprobanteReembolso", sortable: false },
];

export const followUpHeader = [
  { name: "Operador Inicial", value: "name", sortable: false },
  { name: "Operador Final", value: "name", sortable: false },
  { name: "Nro. de caso", value: "contact", sortable: false },
  { name: "Fecha de creación", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  // { name: 'Hora de creación', value: 'status', sortable: false },
  { name: "Estatus", value: "state", sortable: false },
  { name: "Cliente", value: "", sortable: false },
  { name: "Teléfono", value: "", sortable: false },
  { name: "Placa", value: "", sortable: false },
  { name: "Fecha de viaje", value: "", sortable: false },
  { name: "Estado origen", value: "", sortable: false },
  { name: "Ciudad origen", value: "", sortable: false },
  { name: "Estado destino", value: "", sortable: false },
  { name: "Ciudad destino", value: "", sortable: false },
  { name: "Codigo de servicio", value: "", sortable: false },
  // Seguimiento 1
  { name: "Seguimiento 1 planificado", value: "", sortable: false },
  { name: "Fecha de seguimiento 1", value: "", sortable: false },
  { name: "Seguimiento 1 canal", value: "", sortable: false },
  { name: "Seguimiento 1 operador", value: "", sortable: false },
  { name: "Seguimiento 1 observación", value: "", sortable: false },
  // Seguimiento 2
  { name: "Seguimiento 2 planificado", value: "", sortable: false },
  { name: "Fecha de seguimiento 2", value: "", sortable: false },
  { name: "Seguimiento 2 canal", value: "", sortable: false },
  { name: "Seguimiento 2 operador", value: "", sortable: false },
  { name: "Seguimiento 2 observación", value: "", sortable: false },
  // Seguimiento 3
  { name: "Seguimiento 3 planificado", value: "", sortable: false },
  { name: "Fecha de seguimiento 3", value: "", sortable: false },
  { name: "Seguimiento 3 canal", value: "", sortable: false },
  { name: "Seguimiento 3 operador", value: "", sortable: false },
  { name: "Seguimiento 3 observación", value: "", sortable: false },

  // Seguimiento 4
  { name: "Seguimiento 4 planificado", value: "", sortable: false },
  { name: "Fecha de seguimiento 4", value: "", sortable: false },
  { name: "Seguimiento 4 canal", value: "", sortable: false },
  { name: "Seguimiento 4 operador", value: "", sortable: false },
  { name: "Seguimiento 4 observación", value: "", sortable: false },

  // Seguimiento 5
  { name: "Seguimiento 5 planificado", value: "", sortable: false },
  { name: "Fecha de seguimiento 5", value: "", sortable: false },
  { name: "Seguimiento 5 canal", value: "", sortable: false },
  { name: "Seguimiento 5 operador", value: "", sortable: false },
  { name: "Seguimiento 5 observación", value: "", sortable: false },
];

export const PendingPaymentHeader = [
  { name: "Código de servicio", value: "name", sortable: false },
  { name: "Fecha de servicio", value: "name", sortable: false },
  { name: "Cliente", value: "name", sortable: false },
  { name: "Alianza", value: "name", sortable: false },
  { name: "Placa", value: "name", sortable: false },
  { name: "Tipo de Gestión", value: "name", sortable: false },
  { name: "Estatus de pago", value: "name", sortable: false },
  { name: "Monto de deuda", value: "name", sortable: false },
  { name: "Monto pagado USD", value: "name", sortable: false },
  { name: "Monto pagado Bs", value: "name", sortable: false },
  { name: "Fecha de pago", value: "name", sortable: false },
];

export const AVPaymentHeader = [
  { name: "Empresa/Chofer", value: "name", sortable: false },
  { name: "Fecha de servicio", value: "contact", sortable: false },
  { name: "Servicio Prestado", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Tipo de gestión", value: "state", sortable: false },
  { name: "Autorizado por", value: "state", sortable: false },
  { name: "Alianza", value: "state", sortable: false },
  { name: "Código de servicio", value: "status", sortable: false },
  { name: "Placa", value: "state", sortable: false },
  { name: "Marca", value: "", sortable: false },
  { name: "Estado origen", value: "", sortable: false },
  { name: "Ciudad origen", value: "", sortable: false },
  { name: "Monto a pagar proveedor", value: "", sortable: false },
];

export const PaymentHeader = [
  { name: "Empresa/Chofer", value: "name", sortable: false },
  { name: "Fecha de servicio", value: "contact", sortable: false },
  { name: "Servicio Prestado", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Tipo de gestión", value: "state", sortable: false },
  { name: "Código de servicio", value: "status", sortable: false },
  { name: "Placa", value: "state", sortable: false },
  { name: "Marca", value: "", sortable: false },
  { name: "Estado origen", value: "", sortable: false },
  { name: "Ciudad origen", value: "", sortable: false },
  { name: "Monto a pagar proveedor", value: "", sortable: false },
];

export const ProvidersPaymentHeader = [
  {
    name: "Empresa/Chofer",
    value: "name",
    sortable: true,
    filterOptions: [],
    filterSearch: () => {},
  },
  { name: "Fecha de servicio", value: "contact", sortable: false },
  { name: "Servicio Prestado", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Tipo de gestión", value: "state", sortable: false },
  { name: "Alianza", value: "state", sortable: false },
  {
    name: "Código de servicio",
    value: "status",
    sortable: false,
  },
  { name: "Placa", value: "state", sortable: false },
  { name: "Marca", value: "", sortable: false },
  { name: "Estado origen", value: "", sortable: false },
  { name: "Ciudad origen", value: "", sortable: false },
  { name: "Costo del Servicio", value: "", sortable: false },
  { name: "Monto a pagar proveedor", value: "", sortable: false },
  { name: "Estatus de pago", value: "", sortable: false },
  { name: "Fecha de conciliación", value: "", sortable: false },
  { name: "Conciliado por", value: "", sortable: false },
  { name: "Fecha de ejecución de Pago", value: "", sortable: false },
  { name: "Fecha de Pago", value: "", sortable: false },
  { name: "Pagado por", value: "", sortable: false },
  { name: "N de Recibo", value: "", sortable: false },
  { name: "N de Factura", value: "", sortable: false },
  { name: "Factura", value: "", sortable: false },
];

export const AVProvidersPaymentHeader = [
  {
    name: "Empresa/Chofer",
    value: "name",
    sortable: true,
    filterOptions: [],
    filterSearch: () => {},
  },
  { name: "Fecha de servicio", value: "contact", sortable: false },
  { name: "Servicio Prestado", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Tipo de gestión", value: "state", sortable: false },
  { name: "Alianza", value: "state", sortable: false },
  {
    name: "Código de servicio",
    value: "status",
    sortable: false,
  },
  { name: "Placa", value: "state", sortable: false },
  { name: "Marca", value: "", sortable: false },
  { name: "Estado origen", value: "", sortable: false },
  { name: "Ciudad origen", value: "", sortable: false },
  { name: "Averia resuelta", value: "", sortable: false },
  { name: "estatus de la avería resuelta", value: "", sortable: false },
  { name: "Monto a pagar proveedor", value: "", sortable: false },
  { name: "Estatus de pago", value: "", sortable: false },
  { name: "Fecha de conciliación", value: "", sortable: false },
  { name: "Conciliado por", value: "", sortable: false },
  { name: "Fecha de ejecución de Pago", value: "", sortable: false },
  { name: "Fecha de Pago", value: "", sortable: false },
  { name: "Pagado por", value: "", sortable: false },
  { name: "N de Recibo", value: "", sortable: false },
  { name: "N de Factura", value: "", sortable: false },
  { name: "Factura", value: "", sortable: false },
];

export const ParticularCounterHeader = [
  { name: "Nombre", value: "", sortable: false },
  { name: "Servicios activos por operador", value: "", sortable: false },
  { name: "Servicios acumulados", value: "", sortable: false },
  {
    name: "Cantidad de servicios de grúas propias",
    value: "",
    sortable: false,
  },
  {
    name: "Cantidad de servicios de grúa externas",
    value: "",
    sortable: false,
  },
  {
    name: "Cantidad de servicios de grúa externas Caracas",
    value: "",
    sortable: false,
  },
  {
    name: "Cantidad de servicios de grúa externas Interior",
    value: "",
    sortable: false,
  },
  {
    name: "Cantidad de servicios particulares grúa",
    value: "",
    sortable: false,
  },
  {
    name: "Cantidad de servicios particulares de Moto",
    value: "",
    sortable: false,
  },
  { name: "Total Servicios particulares", value: "", sortable: false },
];

export const operatorParticularCounterHeader = [
  { name: "Nombre", value: "", sortable: false },
  {
    name: "Cantidad de servicios de grúas propias",
    value: "",
    sortable: false,
  },
  {
    name: "Cantidad de servicios de grúa externas",
    value: "",
    sortable: false,
  },
  {
    name: "Cantidad de servicios de grúa externas Caracas",
    value: "",
    sortable: false,
  },
  {
    name: "Cantidad de servicios de grúa externas Interior",
    value: "",
    sortable: false,
  },
  {
    name: "Cantidad de servicios particulares grúa",
    value: "",
    sortable: false,
  },
  {
    name: "Cantidad de servicios particulares de Moto",
    value: "",
    sortable: false,
  },
  { name: "Total", value: "", sortable: false },
];

export const supervisorParticularCounterHeader = [
  { name: "Supervisor", value: "", sortable: false },
  {
    name: "Cantidad de servicios particulares",
    value: "",
    sortable: false,
  },
  {
    name: "Pago",
    value: "",
    sortable: false,
  },
];

export const internalTowPaymentHeader = [
  { name: "Chofer", value: "name", sortable: false },
  { name: "Fecha de servicio", value: "contact", sortable: false },
  { name: "Servicio Prestado", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Tipo de gestión", value: "state", sortable: false },
  { name: "Código de servicio", value: "status", sortable: false },
  { name: "Placa", value: "", sortable: false },
  { name: "Marca", value: "", sortable: false },
  { name: "Estado origen", value: "", sortable: false },
  { name: "Ciudad origen", value: "", sortable: false },
  { name: "Costo del servicio", value: "", sortable: false },
  { name: "Monto pagado al chofer", value: "", sortable: false },
];

export const externalTowPaymentHeader = [
  { name: "Chofer", value: "name", sortable: false },
  { name: "Fecha de servicio", value: "contact", sortable: false },
  { name: "Servicio Prestado", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Tipo de gestión", value: "state", sortable: false },
  { name: "Código de servicio", value: "status", sortable: false },
  { name: "Placa", value: "", sortable: false },
  { name: "Marca", value: "", sortable: false },
  { name: "Estado origen", value: "", sortable: false },
  { name: "Ciudad origen", value: "", sortable: false },
  { name: "Costo del servicio", value: "", sortable: false },
  { name: "Monto pagado al chofer", value: "", sortable: false },
];

export const exportableMockup = [
  {
    operator: "Manuel Hernandez",
    time: "3:20pm",
    date: "12/03/2023",
    status: "ACTIVO",
    caseId: "123467789",
    name: "Luis",
    lastName: "Perez",
  },
  {
    operator: "Manuel Hernandez",
    time: "3:20pm",
    date: "12/03/2023",
    status: "ACTIVO",
    caseId: "123467789",
    name: "Luis",
    lastName: "Perez",
  },
  {
    operator: "Manuel Hernandez",
    time: "3:20pm",
    date: "12/03/2023",
    status: "ACTIVO",
    caseId: "123467789",
    name: "Luis",
    lastName: "Perez",
  },
  {
    operator: "Manuel Hernandez",
    time: "3:20pm",
    date: "12/03/2023",
    status: "ACTIVO",
    caseId: "123467789",
    name: "Luis",
    lastName: "Perez",
  },
];

export const serviceHistoryMockup = [
  {
    date: "XXXXXXXXXXXXX",
    fault: "XXXXXXXXXXXXX",
    service: "XXXXXXXXXXXXX",
    observations: "XXXXXXXXXXXXX",
    KMEfectivo: "XXXXXXXXXXXXX",
  },
  {
    date: "XXXXXXXXXXXXX",
    fault: "XXXXXXXXXXXXX",
    service: "XXXXXXXXXXXXX",
    observations: "XXXXXXXXXXXXX",
    KMEfectivo: "XXXXXXXXXXXXX",
  },
  {
    date: "XXXXXXXXXXXXX",
    fault: "XXXXXXXXXXXXX",
    service: "XXXXXXXXXXXXX",
    observations: "XXXXXXXXXXXXX",
    KMEfectivo: "XXXXXXXXXXXXX",
  },
];

export const caseFollowingheader = [
  { name: "Fecha", value: "date", sortable: false },
  { name: "Hora", value: "fault", sortable: false },
  { name: "Status", value: "", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Tipo de seguimiento", value: "observations", sortable: false },
  { name: "Mensaje", value: "KMEfectivo", sortable: false },
  { name: "Observaciones", value: "KMEfectivo", sortable: false },
];

export const scaseFollowingMockup = [
  {
    date: "04/03/2023",
    time: "09:33:01 A.M.",
    status: "En espera de AV",
    type: "Lllamada",
    mesage: "En vía",
    observations: "N/A",
  },
];

export const trazeHeader = [
  { name: "Fecha", value: "date", sortable: false },
  { name: "Hora", value: "fault", sortable: false },
  { name: "Status", value: "", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Duración", value: "observations", sortable: false },
];

export const trazeMockup = [
  {
    date: "04/03/2023",
    time: "10:45:01 A.M.",
    statusOrigin: "",
    statusDestiny: "en espera AV",
    estimatedTime: "min",
    observations: "N/A",
  },
  {
    date: "13/03/23",
    time: "07:36:01 A.M.",
    statusOrigin: "",
    statusDestiny: "en espera AV",
    estimatedTime: "min",
    observations: "N/A",
  },
];

export const bikeTableheader = [
  { name: "Nombre", value: "name", sortable: false },
  { name: "Cédula", value: "cedula", sortable: false },
  { name: "Teléfono", value: "phone", sortable: false },
  { name: "Moto asignada (placa)", value: "plate", sortable: false },
  { name: "Estado", value: "state", sortable: false },
  { name: "Fecha de creación", value: "date", sortable: false },
  { name: "Acción", value: "", sortable: false },
];

export const craneProvidersMockup = [
  {
    name: "TRANSPORTE MACHADO 1974, C.A",
    contact: "MANUEL HERNANDEZ",
    phone: "1234 567 789",
    state: "MIRANDA",
    status: "ACTIVO",
    edit: "",
  },
  {
    name: "TRANSPORTE MACHADO 1974, C.A",
    contact: "MANUEL HERNANDEZ",
    phone: "1234 567 789",
    state: "MIRANDA",
    status: "ACTIVO",
    edit: "",
  },
  {
    name: "TRANSPORTE MACHADO 1974, C.A",
    contact: "MANUEL HERNANDEZ",
    phone: "1234 567 789",
    state: "MIRANDA",
    status: "ACTIVO",
    edit: "",
  },
  {
    name: "TRANSPORTE MACHADO 1974, C.A",
    contact: "MANUEL HERNANDEZ",
    phone: "1234 567 789",
    state: "MIRANDA",
    status: "ACTIVO",
    edit: "",
  },
  {
    name: "TRANSPORTE MACHADO 1974, C.A",
    contact: "MANUEL HERNANDEZ",
    phone: "1234 567 789",
    state: "MIRANDA",
    status: "ACTIVO",
    edit: "",
  },
  {
    name: "TRANSPORTE MACHADO 1974, C.A",
    contact: "MANUEL HERNANDEZ",
    phone: "1234 567 789",
    state: "MIRANDA",
    status: "ACTIVO",
    edit: "",
  },
  {
    name: "TRANSPORTE MACHADO 1974, C.A",
    contact: "MANUEL HERNANDEZ",
    phone: "1234 567 789",
    state: "MIRANDA",
    status: "ACTIVO",
    edit: "",
  },
  {
    name: "TRANSPORTE MACHADO 1974, C.A",
    contact: "MANUEL HERNANDEZ",
    phone: "1234 567 789",
    state: "MIRANDA",
    status: "ACTIVO",
    edit: "",
  },
  {
    name: "TRANSPORTE MACHADO 1974, C.A",
    contact: "MANUEL HERNANDEZ",
    phone: "1234 567 789",
    state: "MIRANDA",
    status: "ACTIVO",
    edit: "",
  },
  {
    name: "TRANSPORTE MACHADO 1974, C.A",
    contact: "MANUEL HERNANDEZ",
    phone: "1234 567 789",
    state: "MIRANDA",
    status: "ACTIVO",
    edit: "",
  },
  {
    name: "TRANSPORTE MACHADO 1974, C.A",
    contact: "MANUEL HERNANDEZ",
    phone: "1234 567 789",
    state: "MIRANDA",
    status: "ACTIVO",
    edit: "",
  },
];

export const bikeMockup = [
  {
    name: "Jose Luis Perez Rodriguez",
    cedula: "1234 567 789",
    phone: "1234 567 789",
    plate: "AH74VF",
    state: "MIRANDA",
    creationDate: "12/03/2023",
  },
  {
    name: "Jose Luis Perez Rodriguez",
    cedula: "1234 567 789",
    phone: "1234 567 789",
    plate: "AH74VF",
    state: "MIRANDA",
    creationDate: "12/03/2023",
  },
  {
    name: "Jose Luis Perez Rodriguez",
    cedula: "1234 567 789",
    phone: "1234 567 789",
    plate: "AH74VF",
    state: "MIRANDA",
    creationDate: "12/03/2023",
  },
  {
    name: "Jose Luis Perez Rodriguez",
    cedula: "1234 567 789",
    phone: "1234 567 789",
    plate: "AH74VF",
    state: "MIRANDA",
    creationDate: "12/03/2023",
  },
  {
    name: "Jose Luis Perez Rodriguez",
    cedula: "1234 567 789",
    phone: "1234 567 789",
    plate: "AH74VF",
    state: "MIRANDA",
    creationDate: "12/03/2023",
  },
  {
    name: "Jose Luis Perez Rodriguez",
    cedula: "1234 567 789",
    phone: "1234 567 789",
    plate: "AH74VF",
    state: "MIRANDA",
    creationDate: "12/03/2023",
  },
  {
    name: "Jose Luis Perez Rodriguez",
    cedula: "1234 567 789",
    phone: "1234 567 789",
    plate: "AH74VF",
    state: "MIRANDA",
    creationDate: "12/03/2023",
  },
];

export const usersTablesMockup = [
  {
    name: "Rubeeeen",
    email: "lorenzo@ruben.com",
    profile: "Administrador de Sistema",
    status: "ACTIVE",
    createdAt: "17/02/2020 17:02:30",
    editedAt: "17/02/2020 17:02:30",
  },
  {
    name: "Rubeeeen",
    email: "lorenzo@ruben.com",
    profile: "Administrador de Sistema",
    status: "ACTIVE",
    createdAt: "17/02/2020 17:02:30",
    editedAt: "17/02/2020 17:02:30",
  },
  {
    name: "Rubeeeen",
    email: "lorenzo@ruben.com",
    profile: "Administrador de Sistema",
    status: "ACTIVE",
    createdAt: "17/02/2020 17:02:30",
    editedAt: "17/02/2020 17:02:30",
  },
  {
    name: "Rubeeeen",
    email: "lorenzo@ruben.com",
    profile: "Administrador de Sistema",
    status: "ACTIVE",
    createdAt: "17/02/2020 17:02:30",
    editedAt: "17/02/2020 17:02:30",
  },
  {
    name: "Rubeeeen",
    email: "lorenzo@ruben.com",
    profile: "Administrador de Sistema",
    status: "ACTIVE",
    createdAt: "17/02/2020 17:02:30",
    editedAt: "17/02/2020 17:02:30",
  },
];

export const cancelServiceHeader = [
  { name: "Servicio", value: "name", sortable: false },
  { name: "Proveedor", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Estatus", value: "state", sortable: false },
  { name: "Codigo de Servicio", value: "state", sortable: false },
  { name: "Acción", value: "", sortable: false },
];

export const providersTablesMockup = [
  {
    name: "Rubeeeen",
    contact: "4142662382",
    region: "Caracas",
    state: "Miranda",
  },
  {
    name: "Rubeeeen",
    contact: "4142662382",
    region: "Caracas",
    state: "Miranda",
  },
  {
    name: "Rubeeeen",
    contact: "4142662382",
    region: "Caracas",
    state: "Miranda",
  },
  {
    name: "Rubeeeen",
    contact: "4142662382",
    region: "Caracas",
    state: "Miranda",
  },
  {
    name: "Rubeeeen",
    contact: "4142662382",
    region: "Caracas",
    state: "Miranda",
  },
];

export const setviceCounterTable = [
  { name: "Servicios", value: "name", sortable: false },
  { name: "Cantidad", value: "name", sortable: false },
  { name: "Monto a Cobrar $", value: "name", sortable: false },
];

// Motorizado
export const externalTowStatsHeaderTable = [
  { name: "Servicio", value: "name", sortable: false },
  { name: "Código de Servicio", value: "name", sortable: false },
  { name: "Placa", value: "name", sortable: false },
  { name: "Fecha de Servicio", value: "name", sortable: false },
  { name: "Monto a Cobrar $", value: "name", sortable: false },
  { name: "Estatus de pago", value: "name", sortable: false },
  { name: "Fecha de Pago", value: "name", sortable: false },
  { name: "Estatus de Conciliacion", value: "name", sortable: false },
  { name: "Comprobante de pago 1", value: "name", sortable: false },
  { name: "Comprobante de pago 2", value: "name", sortable: false },
];

// Gruero Interno y Externo
export const TowStatsHeaderTable = [
  { name: "Servicio", value: "name", sortable: false },
  { name: "Código de Servicio", value: "name", sortable: false },
  { name: "Placa", value: "name", sortable: false },
  { name: "Fecha de Servicio", value: "name", sortable: false },
  { name: "Averia Solventada", value: "name", sortable: false },
  { name: "Costo del Servicio", value: "name", sortable: false },
  { name: "Monto a Cobrar $", value: "name", sortable: false },
  { name: "Estatus de pago", value: "name", sortable: false },
];

export const AVStatsHeaderTable = [
  { name: "Servicio", value: "name", sortable: false },
  { name: "Código de Servicio", value: "name", sortable: false },
  { name: "Placa", value: "name", sortable: false },
  { name: "Fecha de Servicio", value: "name", sortable: false },
  { name: "Averia Solventada", value: "name", sortable: false },
  { name: "Estatus Averia Solventada", value: "name", sortable: false },
  { name: "Monto a Cobrar $", value: "name", sortable: false },
  { name: "Estatus de pago", value: "name", sortable: false },
];

export const reviewsTable = [
  { name: "Código de Servicio", value: "name", sortable: false },
  { name: "Fecha de Servicio", value: "name", sortable: false },
  { name: "Placa", value: "contact", sortable: false },
  { name: "Marca", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Modelo", value: "state", sortable: false },
  { name: "Teléfono", value: "status", sortable: false },
  { name: "Cliente", value: "", sortable: false },
  { name: "Nivel de Refrigerante", value: "", sortable: false },
  { name: "Nivel de Aceite de Motor", value: "", sortable: false },
  { name: "Nivel de aceite de dirección", value: "", sortable: false },
  { name: "Nivel de liga de freno", value: "", sortable: false },
  { name: "Nivel de aceite de caja", value: "", sortable: false },
  //
  { name: "Estado de aceite de motor", value: "", sortable: false },
  { name: "Estado de refrigerante", value: "", sortable: false },
  { name: "Estado de aceite de dirección", value: "", sortable: false },
  { name: "Estado de liga de freno", value: "", sortable: false },
  { name: "Estado de aceite de caja", value: "", sortable: false },
  { name: "Estado de correa de tiempo", value: "", sortable: false },
  { name: "Estado de correa de única", value: "", sortable: false },
  { name: "Estado de correa de alternador", value: "", sortable: false },
  {
    name: "Estado de correa de aire acondicionado",
    value: "",
    sortable: false,
  },
  { name: "Estado de bomba de dirección", value: "", sortable: false },
  { name: "Estado de poleas", value: "", sortable: false },
  { name: "Estado de tensor", value: "", sortable: false },
  {
    name: "Estado de manguera de radiador superior",
    value: "",
    sortable: false,
  },
  {
    name: "Estado de manguera de radiador inferior",
    value: "",
    sortable: false,
  },
  { name: "Estado de toma de termostato", value: "", sortable: false },
  { name: "Estado de envase de refrigerante", value: "", sortable: false },
  //
  { name: "Bote de aceite por tapavalvula", value: "", sortable: false },
  { name: "Bote de aceite por carter de motor", value: "", sortable: false },
  { name: "Bote de aceite por carter de caja", value: "", sortable: false },
  {
    name: "Bote de aceite por estopera delantera de cigüeñal",
    value: "",
    sortable: false,
  },
  { name: "Bote de aceite por estoperas de levas", value: "", sortable: false },
  {
    name: "Bote de aceite por estopera trasera de cigüeñal",
    value: "",
    sortable: false,
  },
  {
    name: "Bote de aceite por estoperas copa caja",
    value: "",
    sortable: false,
  },
  {
    name: "Bote de aceite por mangueras de dirección",
    value: "",
    sortable: false,
  },
  { name: "Bote de aceite por bomba de dirección", value: "", sortable: false },
  { name: "Bote de aceite por transfer", value: "", sortable: false },
  { name: "Bote de aceite por diferencial", value: "", sortable: false },
  {
    name: "Bote de refrigerante por tanque superior de radiador",
    value: "",
    sortable: false,
  },
  {
    name: "Bote de refrigerante por tanque inferior de radiador",
    value: "",
    sortable: false,
  },
  //
  { name: "PSI Bomba de gasolina", value: "", sortable: false },
  //
  { name: "Comentarios", value: "", sortable: false },
];

export const conciliateTableHeader = [
  { name: "Empresa/Chofer", value: "name", sortable: false },
  { name: "Fecha de servicio", value: "contact", sortable: false },
  { name: "Servicio Prestado", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Tipo de gestión", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Código de servicio", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Monto a pagar proveedor		", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
];

export const fleetManteinanceTableHeader = [
  { name: "Tipo de unidad", value: "unitType", sortable: false },
  { name: "Unidad", value: "unit", sortable: false },
  { name: "Estatus Unidad", value: "unitStatus", sortable: false },
  { name: "Tipo de mantenimiento", value: "maintenanceType", sortable: false },
  { name: "Sistema", value: "system", sortable: false },
  { name: "componente", value: "component", sortable: false },
  { name: "Comentario", value: "detail", sortable: false },
  { name: "KM", value: "km", sortable: false },
  { name: "Costo", value: "cost", sortable: false },
  { name: "Proveedor", value: "provider", sortable: false },
  { name: "Fecha de entrada", value: "entryDate", sortable: false },
  { name: "Fecha de salida", value: "exitDate", sortable: false },
  { name: "Acción", value: "action", sortable: false },
];

export const fleetIncidenceTableHeader = [
  { name: "Tipo de unidad", value: "unitType", sortable: false },
  { name: "Unidad", value: "unit", sortable: false },
  { name: "Estatus Unidad", value: "unitStatus", sortable: false },
  { name: "Fecha del siniestro", value: "accidenDate", sortable: false },
  { name: "Chofer responsable", value: "driver", sortable: false },
  { name: "Zona del siniestro", value: "accidentLocation", sortable: false },
  { name: "Detalle", value: "detail", sortable: false },
  { name: "Acción", value: "action", sortable: false },
];

export const AddProvidersTableHeader = [
  { name: "Nombre", value: "name", sortable: false },
  { name: "Cedula", value: "contact", sortable: false },
  { name: "Telefono", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Estado", value: "state", sortable: false },
  { name: "Tipo", value: "status", sortable: false },
  { name: "Estatus", value: "", sortable: false },
  { name: "Accion", value: "", sortable: false },
];

export const PendingAVFaultsResolvedHeader = [
  { name: "Fecha del servicio", value: "serviceDate", sortable: false },
  { name: "Código del servicio", value: "unitStatus", sortable: false },
  { name: "Motorizado", value: "biker", sortable: false },
  { name: "Estatus", value: "status", sortable: false },
  { name: "Validado por", value: "validatedBy", sortable: false },
  { name: "Acciones", value: "actions", sortable: false },
];

export const DailyReportTableHeader = [
  { name: "Fecha de solicitud", value: "contact", sortable: false },
  { name: "Inicio de turno", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Fin de turno", value: "state", sortable: false },
  { name: "Solicitado por", value: "status", sortable: false },
  { name: "Quejas reportadas", value: "", sortable: false },
  { name: "Servicios particulares", value: "", sortable: false },
  { name: "Agendados", value: "", sortable: false },
  { name: "Servicios activos", value: "", sortable: false },
  { name: "Servicios prestados", value: "", sortable: false },
  { name: "Grúas propias", value: "", sortable: false },
  { name: "Grúas externas", value: "", sortable: false },
];

export const complaintsTableHeader = [
  { name: "Fecha de la queja", value: "name", sortable: false },
  { name: "Servicio", value: "contact", sortable: false },
  { name: "Cliente", value: "phone", sortable: false }, //   { name: 'Región', value: 'region' },
  { name: "Nro. de contacto", value: "color", sortable: false },
  { name: "Tipificación", value: "alias", sortable: false },
  { name: "Estatus de la queja", value: "state", sortable: false },
  { name: "Solución", value: "status", sortable: false },
  { name: "Monto", value: "status", sortable: false },
  { name: "Satisfacción del cliente", value: "", sortable: false },
  { name: "Categoria", value: "", sortable: false },
  { name: "Placa", value: "", sortable: false },
  { name: "Red Social", value: "", sortable: false },
  { name: "Colaborador responsable", value: "", sortable: false },
  { name: "Nombre del colaborador", value: "", sortable: false },
  { name: "Segmentación", value: "", sortable: false },
  { name: "Acciones", value: "", sortable: false },
];

export const editServicePaymentTableHeader = [
  { name: "Tipo", value: "name", sortable: false },
  { name: "Monto USD", value: "name", sortable: false },
  { name: "Monto Bs", value: "name", sortable: false },
  { name: "Metodo", value: "name", sortable: false },
  { name: "Referencia", value: "name", sortable: false },
  { name: "Titular de la cuenta", value: "name", sortable: false },
  { name: "Caja de venta", value: "name", sortable: false },
  { name: "Ver Comprobante", value: "name", sortable: false },
  { name: "Fecha de pago", value: "name", sortable: false },
  { name: "Ordenes Asociadas", value: "name", sortable: false },
  { name: "Accion", value: "name", sortable: false },
];

export const batterySalesTableHeader = [
  { name: "Empresa", value: "name", sortable: false },
  { name: "Modelo de Batería", value: "name", sortable: false },
  { name: "Precio", value: "name", sortable: false },
  { name: "Cantidad Disponible", value: "name", sortable: false },
];

export const batteryApplicationTableHeader = [
  { name: "Empresa", value: "name", sortable: false },
  { name: "Modelo de Batería", value: "name", sortable: false },
  { name: "Marca", value: "name", sortable: false },
  { name: "Modelo", value: "name", sortable: false },
  { name: "Año", value: "name", sortable: false },
];

export const TVProvidersCounterHeader = [
  { name: "Asesor", value: "name", sortable: false },
  { name: "Servicios activos", value: "name", sortable: false },
  { name: "Servicios acumulados", value: "name", sortable: false },
];

export const servScalePriceHistoryTableHeader = [
  { name: "Variable", value: "field", sortable: false },
  { name: "Fecha aplicación", value: "recordDateSince", sortable: false },
  { name: "Valor anterior", value: "from", sortable: false },
  { name: "Valor nuevo", value: "to", sortable: false },
  { name: "Modificado por", value: "createdBy", sortable: false },
];

export const operationsCommissionHistoryTableHeader = [
  { name: "Comisión", value: "field", sortable: false },
  { name: "Fecha aplicación", value: "recordDateSince", sortable: false },
  { name: "Valor anterior", value: "from", sortable: false },
  { name: "Valor nuevo", value: "to", sortable: false },
  { name: "Modificado por", value: "createdBy", sortable: false },
];

export const particularClientsTableHeader = (
  channels,
  actions,
  serviceTypes
) => [
  { name: "Nombre y Apellido", value: "", sortable: false },
  { name: "Cedula", value: "name", sortable: false },
  { name: "Numero", value: "", sortable: false },
  { name: "Fecha Servicio", value: "name", sortable: false },
  { name: "Ciudad", value: "", sortable: false },
  {
    name: "Canal",
    value: "",
    sortable: true,
    filterOptions: channels,
    filterSearch: actions.channels,
  },
  {
    name: "Tipo de servicio",
    value: "",
    sortable: true,
    filterOptions: serviceTypes,
    filterSearch: actions.serviceTypes,
  },
  {
    name: "Afiliado",
    value: "",
    sortable: true,
    filterOptions: [
      { name: "Sí", _id: "true" },
      { name: "No", _id: "false" },
    ],
    filterSearch: actions.affiliated,
  },
];
